import Vue from 'vue'

Vue.component('PageHeader', (_) => import('../components/common/page/PageHeader'))

Vue.component('PageSection', (_) => import('../components/common/page/PageSection'))

Vue.component('LogoImage', (_) => import('../components/common/logo/LogoImage'))

Vue.component('LogoText', (_) => import('../components/common/logo/LogoText'))

Vue.component('BasicButton', (_) => import('../components/common/button/BasicButton'))

Vue.component('HrSolid', (_) => import('../components/common/grid/HrSolid'))

Vue.component('BasicCheckbox', (_) => import('../components/common/input/Checkbox.vue'))

Vue.component('ErrorText', (_) => import('../components/common/text/ErrorText.vue'))
